// extracted by mini-css-extract-plugin
module.exports = {"shareButton":"ShareButton_shareButton__3EWOk","notification":"ShareButton_notification__2SUvW"};